<ul class="breadcrumb-ul">
    <ol class="breadcrumb">
        <li class="breadcrumb-item">
            <a (click)="routeToPage('/')">
                <mat-icon aria-hidden="false" aria-label="Home icon" fontIcon="home"></mat-icon>
            </a>
        </li>
        <ng-container *ngIf="isSmallScreen && !isSinglePage(); else fullBreadcrumb">
            <li class="breadcrumb-item ellipsis-item" (click)="$event.stopPropagation()">
                <span class="ellipsis" (click)="toggleDropdown()" style="cursor: pointer;">
                    ...
                </span>

                <div class="dropdown-menu" *ngIf="showDropdown" (click)="$event.stopPropagation()">
                    <a *ngFor="let label of breadcrumblabels?.mainPage" class="dropdown-item non-clickable">
                        {{ label }}
                    </a>

                    <a *ngIf="breadcrumblabels?.subpage" class="dropdown-item clickable"
                        (click)="routeToPage(breadcrumblabels?.subpage['route'])">
                        {{ breadcrumblabels?.subpage['name'] }}
                    </a>

                    <a class="dropdown-item clickable" (click)="routeToInitialPage()">
                        {{ initalLabel }}
                    </a>

                    <a *ngIf="breadcrumblabels?.intermediatePage" class="dropdown-item clickable"
                        (click)="routeToPage(breadcrumblabels?.intermediatePage['route'])">
                        {{ breadcrumblabels?.intermediatePage['name'] }}
                    </a>
                </div>
            </li>
        </ng-container>


        <ng-template #fullBreadcrumb>

            <li *ngFor="let label of breadcrumblabels?.mainPage"
                class="breadcrumb-item prev-text non-clickable-breadcrumb">
                {{ label }}
            </li>
            <li *ngIf="breadcrumblabels?.subpage" class="breadcrumb-item prev-text breadcrumb-click"
                (click)="routeToPage(breadcrumblabels?.subpage['route'])">{{breadcrumblabels?.subpage['name']}}</li>
            <li class="breadcrumb-item prev-text breadcrumb-click" (click)="routeToInitialPage()">{{initalLabel}}</li>
            <li *ngIf="breadcrumblabels?.intermediatePage" class="breadcrumb-item prev-text breadcrumb-click"
                (click)="routeToPage(breadcrumblabels?.intermediatePage['route'])">
                {{breadcrumblabels?.intermediatePage['name']}}</li>
        </ng-template>
        <li class="breadcrumb-item" *ngIf="secondaryLabel" aria-current="page">{{ secondaryLabel }}</li>
        <!-- <li *ngIf="!showtaxpayer" class="breadcrumb-item" aria-current="page"
            (click)="routeToPage('/taxpayer/taxAgents')" style="cursor: pointer;">
            {{ "Appoint a Tax Agent" }}
        </li> -->
    </ol>
</ul>

<div class="layout" id="otb-layout">
    <div class="sidebar" *ngIf="!showLoading && showContent && (data()?.sideMenu?.length || 0) > 0">
        <div class="row">
            <div id="sub-menu-page-routing">
                <button class="menu-div-toggle-btn" (click)="toggleSidebar()">
                    <span>S</span>
                    <span class="E">U</span>
                    <span>B</span>
                    <span>M</span>
                    <span class="E">E</span>
                    <span>N</span>
                    <span>U</span>
                </button>
            </div>
            <div class="menu-div" [ngClass]="{ 'open': isSidebarVisible, 'sticky': isStickySidebar }">
                <div class="menu-div-close-btn">
                    <button (click)="toggleSidebar()">X</button>
                </div>
                <app-side-menu [items]="data()?.sideMenu || []" [selectedId]="selectedId()"
                    (itemSelected)="onSelect($event)"> </app-side-menu>

            </div>

            <div class="div-content">
                <ng-content select="[sideNavContent]"></ng-content>
                <ng-container *ngIf="!navigationOnly && data() as d">
                    <app-side-menu-content-render [section]="d.menuContent[selectedId()]"
                        [parentComponent]="parentComponent" [loadingData]="showShimmer" [noData]="noData"></app-side-menu-content-render>
                </ng-container>
            </div>
        </div>
    </div>
    <!-- Empty side menu fallback -->
    <div class="sidebar empty" *ngIf="!showLoading && showContent && (data()?.sideMenu?.length || 0) === 0">
        <div class="div-content">
            <ng-content select="[sideNavContent]"></ng-content>
            <ng-container *ngIf="!navigationOnly && data() as d">
                <app-side-menu-content-render [section]="d.menuContent[selectedId()]"
                    [parentComponent]="parentComponent"></app-side-menu-content-render>
            </ng-container>
        </div>
    </div>
    <div class="content" *ngIf="showLoading">
        <app-loader></app-loader>
    </div>
    <div class="content" *ngIf="!showLoading && !showContent">
        <app-data-unavailable></app-data-unavailable>
    </div>

    <div class="rating">
        <app-rating></app-rating>
    </div>
</div>